<template>
    <span class="portal-logo">
        <a :href="post.post.url" target="_blank">
            <img v-if="post.post.host=='pornhub'" :style="styles" src="../../assets/img/logos/pornhub.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='xhamster'" :style="styles" src="../../assets/img/logos/xhamster.svg" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='tumblr'" :style="styles" src="../../assets/img/logos/tumblr.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='porndig'" :style="styles" src="../../assets/img/logos/porndig.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='xnxx'" :style="styles" src="../../assets/img/logos/xnxx.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='xvideos'" :style="styles" src="../../assets/img/logos/xvideos.svg" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='hypnotube'" :style="styles" src="../../assets/img/logos/hypnotube.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='motherless'" :style="styles" src="../../assets/img/logos/motherless.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='ashemaletube'" :style="styles" src="../../assets/img/logos/ashemaletube.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='sex'" :style="styles" src="../../assets/img/logos/sexdotcom.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='sheshaft'" :style="styles" src="../../assets/img/logos/sheshaft.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='eroprofile'" :style="styles" src="../../assets/img/logos/eroprofile.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='youjizz'" :style="styles" src="../../assets/img/logos/youjizz.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='youtrannytube'" :style="styles" src="../../assets/img/logos/youtrannytube.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='fulltrannytube'" :style="styles" src="../../assets/img/logos/fulltrannytube.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='trannytube'" :style="styles" src="../../assets/img/logos/trannytubetv.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='spankwire'" :style="styles" src="../../assets/img/logos/spankwire.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='dirtyship'" :style="styles" src="../../assets/img/logos/dirtyship.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='nsfw247'" :style="styles" src="../../assets/img/logos/NSFWonSnap.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='hotscope'" :style="styles" src="../../assets/img/logos/hotscope.png" :title="altTitle" :alt="altTitle">
            <img v-if="post.post.host=='tiktits'" :style="styles" src="../../assets/img/logos/tiktits.svg" :title="altTitle" :alt="altTitle">
        </a>
    </span>
</template>

<script>

    const portalBgs = {
      pornhub: '#000000',
      xvideos: '#000000',
      tumblr: 'rgb(54, 70, 93)',
      motherless: '#000000',
      ashemaletube: '#000000',
      sheshaft: 'rgb(47, 51, 63)',
      eroprofile: 'rgb(0, 105, 198)',
    };

    export default {
        name: '',
        props: ['post','mh', 'usebg'],
        data() {
            return {}
        },
        created() {
        },
        computed:{
            styles(){
                let styles = [];
                if(this.mh) styles.push('max-height:'+this.mh);
                if(this.usebg && portalBgs[this.post.post.host]){
                  styles.push('background-color:'+portalBgs[this.post.post.host]);
                  styles.push('padding: 4px');
                }
                return styles.join(';');
            },
            altTitle(){
                return "View "+this.post.post.title+" on "+this.post.post.host;
            }
        },
        methods: {

            getLogo(){
                switch(this.post.post.host){
                    case 'pornhub': return '';
                    case 'xhamster': return '';
                }
            }
        }
    }
</script>

<style lang="sass" scoped>
    a
        text-decoration: none
</style>



// WEBPACK FOOTER //
// src/components/ui/PortalLogo.vue